'use strict';

export default class OPLPayFine {
    constructor() {
        this.payfineFormWrapper = null;
        this.payfineForm = null;
        this.successTransactionID = null;
    }

    init() {
        this.payfineFormWrapper = document.querySelector('#payfine-form-wrapper');
        this.payfineForm = document.querySelector('#payfine-form');
        this.successTransactionID = document.querySelector('#payfine-success-id');

        if (this.payfineForm) {
            this.payfineForm.addEventListener('submit', (e) => {
                this.handleFormSubmit(e);
            });
        }

        if (this.successTransactionID) {
            const urlParams = new URLSearchParams(window.location.search);
            const transactionId = urlParams.get("transactionId");

            if (transactionId) {
                this.successTransactionID.textContent = transactionId;
            }
        }
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const formData = new FormData(this.payfineForm);

        const loader = this.payfineForm.querySelector('.opl-loader');

        if (loader) loader.style.display = 'block';

        fetch('/api/payfine/postfine', {
            method: 'POST',
            body: formData
        })
            .then(response => {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    return response.json();
                } else {
                    return response.text();
                }
            })
            .then(data => {
                if (typeof data === "string") {
                    // Validation errors: replace form with partial
                    this.payfineFormWrapper.innerHTML = data;
                    this.init();
                } else if (data.success && data.redirectUrl) {
                    // Redirect to Checkout page
                    window.location.href = data.redirectUrl;
                }
            })
            .catch(error => {
                console.error("Error submitting form:", error);
            })
            .finally(() => {
                if (loader) loader.style.display = 'none';
            });
    }
}
